<template>
  <div
    class="payBg"
    :class="[hasBackgroundImage ? 'payBg-hasBackgroundImage' : '']"
  >
    <CancelModal
      v-if="showCancelModal"
      :header="$t('payment.cancel_modal.header')"
      :title="$t('payment.cancel_modal.title')"
      :button_text_deny="$t('payment.cancel_modal.button.deny')"
      :button_text_approve="$t('payment.cancel_modal.button.approve')"
      @onConfirm="confirm_cancel_cash_payment"
      @onClose="showCancelModal = false"
    >
    </CancelModal>
    <PaymentModal
      v-if="showError"
      @abort="abort"
      @try_again="try_again"
      @back_to_cart="back_to_cart"
      :title="currentPaymentErrorTitle"
      :text="currentPaymentErrorText"
    >
    </PaymentModal>
    <order-header :is-payment="true" ref="orderHeader" />
    <div class="headerWrapper" v-if="!isQrCodePhase">
      <div
        class="headerTitle"
        :class="[isDone ? 'headerTitle-isDone' : 'headerTitle-isProgress']"
      >
        {{ $t("payment.order") }}
        {{ isDone ? $t("payment.success") : $t("payment.complete") }}
      </div>
    </div>
    <div
      class="circleSpace"
      :class="isQrCodePhase ? 'circleSpace-isQtyLayout' : ''"
    ></div>
    <div
      class="resultBlock"
      :class="isQrCodePhase ? 'resultBlock-isQtyLayout' : ''"
    >
      <div
        v-if="
          (isDone && shouldShowOrderNumber) ||
            (isQrCodePhase && isQrCodeCheckout)
        "
        class="numberBlock"
      >
        <div class="menuHeaderText">
          {{ $t(`payment.order_number`) }}
        </div>
        <div class="numberBox">
          {{ ordernumber }}
        </div>
      </div>
      <div
        class="videoBlock"
        :class="isQrCodePhase ? 'videoBlock-isQtyLayout' : ''"
      >
        <div v-if="isQrCodePhase" class="qrCodeImage">
          <div class="qrCodeImage-Head">
            {{ $t("payment.qty.title") }}
          </div>
          <div class="qrCodeImage-Arrow"></div>
          <div class="qrCodeImage-ImgContainer">
            <img id="qrCodeImage" />
          </div>
        </div>
        <video
          loop
          autoplay
          muted
          v-if="activeProgress.id === 'pay'"
          :src="videoSrcPayment()"
          playsinline
        />
        <video
          autoplay
          muted
          v-if="activeProgress.id === 'ticket'"
          :src="videoSrc('print')"
          playsinline
        />
        <video
          autoplay
          muted
          v-if="activeProgress.id === 'completion'"
          :src="videoSrc(endVideo)"
          playsinline
        />
        <div
          class="videoSubtext"
          v-if="activeProgress.id === 'completion'"
          v-html="$t('payment.video.' + endVideo)"
        ></div>
      </div>
      <div
        class="progressBlock"
        :class="isQrCodePhase ? 'progressBlock-isQtyLayout' : ''"
      >
        <div class="progressTitle" v-html="activeProgress.title"></div>
        <div
          class="progressText"
          :class="{
            green: stepPay.status === 'active' && stepPay.payment === 'success',
            red: stepPay.status === 'active' && stepPay.payment === 'fail'
          }"
        >
          <span
            :class="{ progressTextCikam: isCikam }"
            v-html="activeProgress.text"
          ></span>
        </div>
        <div
          v-if="
            stepPay.status === 'active' &&
              isDldBasket &&
              dldTransmissionStatus.error
          "
          v-html="$t('payment.dld.fail')"
          class="progressText"
        ></div>
        <video
          v-if="
            !isCikam &&
              stepPay.status === 'active' &&
              stepPay.payment === 'success'
          "
          autoplay
          muted
          src="~@/assets/green_checkmark.webm"
          playsinline
        />
        <video
          v-if="
            !isCikam &&
              stepPay.status === 'active' &&
              stepPay.payment === 'fail'
          "
          autoplay
          muted
          src="~@/assets/red_cross.webm"
          playsinline
        />

        <cikam
          ref="cikam"
          v-if="isCikam && stepPay.status === 'active'"
          @cashOut="onCashOut"
        ></cikam>
      </div>
      <div
        v-if="isCikam && stepPay.status === 'active' && shouldShowCancelButton"
      >
        <div class="actionBlock">
          <div class="cancelBtn text" @click="cancelPayment">
            {{ $t(`payment.betaling.cancel`) }}
          </div>
        </div>
      </div>
      <div v-if="isDone" class="startBlock">
        <div class="startBtn" @click="home">
          {{ $t(`payment.start_new`) }}
        </div>
        <div v-if="isQrCodePhase" class="startBtnInfoText">
          {{ $t(`payment.start_new_info`) }}
        </div>
      </div>
      <div
        v-else
        :class="{
          end:
            stepPay.status === 'active' ||
            (stepCompletion.status === 'active' &&
              stepCompletion.puck === true),
          start: stepTicket.status === 'active'
        }"
        class="arrowBox"
      >
        <video
          v-if="!isCikam"
          loop
          autoplay
          muted
          class="arrowImg"
          :src="videoSrc('arrows')"
          playsinline
        />
      </div>
    </div>
  </div>
</template>
<script>
import PaymentModal from "@/components/modals/payment.vue";
import CancelModal from "@/components/modals/confirm.vue";
import api from "../api/orderkiosk";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { getOffer, productToBasketItem } from "@/utils/products";
import { totalPriceCents } from "@/utils/pricing";
import { get_kiosk_options, getNumberSystem } from "@/utils/wbsIntegration";
import {
  cancel,
  debit,
  resetPaymentTimout,
  transmission_status
} from "@/api/payment";
import { basketToReceipt } from "@/utils/receipt";
import OrderHeader from "@/components/order/OrderHeader";
import {
  determine_hostname,
  determineVideoSrc,
  isBackgroundImageSet
} from "@/utils/helpers";
import { getInitialState } from "@/utils/orderStateUtil";
import Cikam from "@/components/payment/Cikam";
import {
  basketContainsOnlyScannedProducts,
  basketContainsOnlySelfServiceProducts,
  basketContainsSelfServiceNotScanned,
  basketContainsServiceProductNotScanned
} from "@/utils/selfservice";
import { isScanEnabled } from "@/utils/checkout";
import {
  containsDelayedDeliveryProduct,
  getDldData,
  handleExtendasDelayedDelivery
} from "@/api/delayedDelivery";

export default {
  components: {
    Cikam,
    CancelModal,
    PaymentModal,
    OrderHeader
  },
  data() {
    return {
      isDldBasket: false,
      dldTransmissionStatus: {},
      paymentData: {},
      pagerResponse: {},
      endVideo: "loudspeaker",
      prepared: false,
      timer: null,
      productsOfTheShelfOnly: false,
      currentErrorCode: "",
      currentPaymentErrorTitle: "",
      currentPaymentErrorText: "",
      showError: false,
      showCancelModal: false,
      ordernumber: 0,
      progress: [
        {
          id: "pay",
          title: "Betaling",
          text: "",
          status: "active",
          payment: "unknown"
        },
        {
          id: "qrcode",
          title: "QR Code",
          text: "",
          status: "inactive"
        },
        {
          id: "ticket",
          title: "Ticket",
          text: "",
          status: "inactive"
        },
        {
          id: "completion",
          status: "inactive",
          puck: false
        }
      ],
      isDone: false
    };
  },
  computed: {
    ...mapGetters({
      basket: "BASKET",
      coupons: "COUPONS",
      project: "PROJECT",
      offers: "OFFERS",
      products: "PRODUCTS",
      isToTake: "TO_TAKE",
      delivery_method: "DELIVERY_METHOD_FULL",
      schedules: "SCHEDULES",
      next_puck: "NEXT_PUCK",
      manual_puck: "MANUAL_PUCK",
      terminal: "TERMINAL",
      terminals: "TERMINALS",
      txid: "TXID",
      cikamResponse: "CIKAM_RESPONSE",
      isCikam: "IS_CIKAM",
      site_setting: "SITE_SETTING",
      current_language: "CURRENT_LANGUAGE",
      currency_code: "CURRENCY_CODE"
    }),
    insertedAmount() {
      //insertedAmount used as watch expression
      return (
        this.cikamResponse["details"] &&
        this.cikamResponse["details"]["InsertedAmount"]
      );
    },
    shouldShowCancelButton() {
      if (!this.cikamResponse["details"]) {
        return false;
      }
      const WAITING_INSERTION_OF_CASH = 3;
      const COUNTING = 4;
      let paymentAmount = parseInt(
        this.cikamResponse["details"]["PaymentAmount"]
      );
      let insertedAmount = parseInt(
        this.cikamResponse["details"]["InsertedAmount"]
      );
      return (
        [WAITING_INSERTION_OF_CASH, COUNTING].includes(
          this.cikamResponse["details"]["StatusCode"]
        ) && insertedAmount < paymentAmount
      );
    },
    hasBackgroundImage() {
      return isBackgroundImageSet("--page_Payment_background-image");
    },
    offerProducts() {
      const offer = getOffer(this.offers, "WAITING_TIME", this.schedules);
      if (!offer) return [];
      const products_ids = offer.products.map(elem => elem.id);
      return this.products.filter(item => products_ids.indexOf(item.id) !== -1);
    },
    activeProgress() {
      let p = this.progress.find(p => p.status === "active");
      if (!p) {
        return { header: "test", title: "test", id: "test" };
      }
      return p;
    },
    phase() {
      return this.activeProgress.id;
    },
    isQrCodeCheckout() {
      return (
        this.shouldShowQrCode &&
        basketContainsServiceProductNotScanned(this.basket)
      );
    },
    isQrCodePhase() {
      return this.phase === "qrcode";
    },
    shouldShowQrCode() {
      return (
        this.getCurrentDeliveryMethodAttribute("show_qr_code", false) &&
        this.ordernumber !== -1
      );
    },
    shouldShowOrderNumber() {
      return this.getCurrentDeliveryMethodAttribute("show_order_number", true);
    },
    stepPay() {
      return this.getProgress("pay");
    },
    stepTicket() {
      return this.getProgress("ticket");
    },
    stepCompletion() {
      return this.getProgress("completion");
    }
  },
  methods: {
    proceedWithStep(param_id) {
      this.activeProgress.status = "done";
      this.getProgress(param_id).status = "active";
    },
    getProgress(param_id) {
      return this.progress.find(p => p.id === param_id);
    },
    getCurrentDeliveryMethodAttribute(attributeName, defaultValue) {
      let kiosk_options = get_kiosk_options();
      let rv = defaultValue;
      let order_complete_actions = kiosk_options.order_complete_actions;
      if (order_complete_actions) {
        let o = order_complete_actions.find(
          e => e.delivery_method === this.delivery_method.identifier
        );
        if (o && typeof o[attributeName] !== "undefined") {
          rv = o[attributeName];
        }
      }
      return rv;
    },
    getHostname() {
      let hostname = determine_hostname();
      if (hostname) {
        console.log("getHostname = " + hostname);
        return hostname;
      } else {
        console.log("Error NoHostname");
        return "";
      }
    },
    onCashOut() {
      this.getProgress("pay").text = this.$t("payment.betaling.text_cash_out");
    },
    initEndVideoByKioskOptions() {
      let kiosk_options = get_kiosk_options();
      let video = "loudspeaker";
      let order_complete_actions = kiosk_options.order_complete_actions;
      if (order_complete_actions) {
        let o = order_complete_actions.find(
          e => e.delivery_method === this.delivery_method.identifier
        );
        if (o && typeof o.video !== "undefined") {
          video = o.video;
        }
      }
      this.endVideo = video;
      console.log("initEndVideoByKioskOptions video: " + video);
    },
    overwriteEndVideoForSelfService() {
      if (basketContainsOnlyScannedProducts(this.basket)) {
        this.endVideo = "products_of_the_shelf_scanned";
      } else if (basketContainsOnlySelfServiceProducts(this.basket)) {
        this.endVideo = "products_of_the_shelf";
      } else if (basketContainsSelfServiceNotScanned(this.basket)) {
        let endVideoKeys = ["orderscreen", "buzzer_takeaway", "loudspeaker"];
        if (endVideoKeys.includes(this.endVideo)) {
          this.endVideo = this.endVideo + "_selfservice";
        }
      } else {
        console.log("setSelfServiceEndVideo n.a.");
      }
    },
    videoSrcPayment() {
      if (this.isCikam) {
        return this.videoSrc("payment_cash");
      } else {
        return this.videoSrc("payment");
      }
    },
    videoSrc(videoName) {
      return determineVideoSrc("--page_Payment_webm_key_", videoName);
    },
    resetPaymentTimout() {
      resetPaymentTimout(this.txid, this.terminal.terminal);
    },
    cancelPayment() {
      // cash payment can be canceled if status is "waiting insertion of cash"
      const STATUS_WAITING_INSERTION_OF_CASH = 3;
      if (
        this.cikamResponse &&
        this.cikamResponse["details"] &&
        this.cikamResponse["details"]["StatusCode"] ===
          STATUS_WAITING_INSERTION_OF_CASH
      ) {
        console.log(
          "cancelPayment for terminal " + JSON.stringify(this.terminal.terminal)
        );
        if (this.txid) {
          console.log("cancelPayment txid: " + this.txid);
          this.showCancelModal = true;
        } else {
          console.log("cancelPayment back to cart");
          this.$emit("back_to_cart");
        }
      }
    },
    home: function() {
      this.logAudit({
        category: "PAGE",
        event: "CLOSE",
        data: "successfull order"
      });
      this.logRouter({ name: "home", router: this.$router });
    },
    async getOrderNumber() {
      let counter;
      try {
        let s = getNumberSystem();
        if (!s) return -1;
        counter = await s.increment("counter");
        if (!counter) return -1;
      } catch (e) {
        console.log("Error while getting order Number:", e);
        counter = -1;
      }
      return counter;
    },
    async setOrderNumberStatus(counter, paramStatus, paramTxid) {
      let result;
      try {
        let s = getNumberSystem();
        if (!s)
          return {
            info: "Number system not available",
            value: null,
            error: true
          };
        let orderNumberStatusPayload = {
          hostname: this.getHostname(),
          status: paramStatus,
          timestamp: parseInt(Date.now() / 1000),
          timestamp_preparation_started: parseInt(Date.now() / 1000),
          timestamp_preparation_finished: 0,
          txid: paramTxid,
          puck: this.next_puck,
          reported: false,
          pager_id: this.pagerResponse.id
        };
        this.logAudit({
          category: "ORDER",
          event: "ADD_ORDER_NUMBER_STATUS",
          data: orderNumberStatusPayload
        });
        result = await s.set("orders." + counter, orderNumberStatusPayload);
      } catch (e) {
        console.log("Error while setting order number status:", e);
        result = {
          info: "Error while setting order number status",
          value: null,
          error: true
        };
      }
      return result;
    },
    addBasket(item) {
      const basketItem = productToBasketItem(item);
      basketItem.count = 1;
      const newBasket = [basketItem];
      this.setBasket(newBasket);
      this.logAudit({
        category: "CART",
        event: "ADD_PRODUCT",
        data: item
      });
      this.logRouter({ name: "order", router: this.$router });
    },
    ...mapMutations({
      setBasket: "SET_BASKET",
      setNextPuck: "SET_NEXT_PUCK",
      lock_kiosk: "LOCK",
      setCikamResponse: "SET_CIKAM_RESPONSE",
      setManualPuck: "SET_MANUAL_PUCK",
      setCustomerPrinterResponse: "SET_CUSTOMER_PRINTER_RESPONSE"
    }),
    prepare() {
      console.log("prepare");
      this.isDldBasket = false;
      this.dldTransmissionStatus = {};
      this.paymentData = {};
      this.pagerResponse = {};
      if (this.isCikam) {
        this.setCikamResponse({});
      }
      if (this.prepared) {
        //this is a retry.
        this.pay();
        return;
      }
      this.initEndVideoByKioskOptions();
      this.overwriteEndVideoForSelfService();
      let promise_order_number = this.getOrderNumber().then(number => {
        this.ordernumber = number;
      });
      let promise_next_puck;
      if (this.manual_puck) {
        promise_next_puck = new Promise((resolve, reject) => {
          // this.setNextPuck is pyramid specific, wording should be refactored
          this.setNextPuck({
            puckNr: parseInt(this.manual_puck),
            puckId: "",
            type: "manual"
          });
          resolve();
        });
      } else {
        promise_next_puck = api.getPuckInfo().then(r => {
          console.log("getPuckInfo via api");
          if (r.data.nextPuck) {
            this.setNextPuck({ ...r.data.nextPuck, type: "pyramid" });
          }
        });
      }

      Promise.all([promise_order_number, promise_next_puck])
        .then(this.pay)
        .catch(err => {
          console.log(err);
          this.currentPaymentErrorTitle = this.$t("payment.error");
          this.currentPaymentErrorText = err.toString();
          this.showError = true;
        });
    },
    pay() {
      this.prepared = true;
      this.logAudit({
        category: "ORDER",
        event: "PAYMENT_REQUESTED"
      });
      this.getProgress("pay").title = this.$t("payment.betaling.title");
      this.getProgress("pay").status = "active";
      this.getProgress("pay").payment = "unknown";
      if (this.isCikam) {
        this.getProgress("pay").text = this.$t(
          "payment.betaling.text_cash_start"
        );
      } else {
        this.getProgress("pay").text = this.$t("payment.betaling.text");
      }
      let coupons = [];
      this.basket.forEach(bi => {
        if (!bi.selectedCombo && bi.coupon) coupons.push(bi.coupon.ticket);
      });
      this.coupons.forEach(coupon => coupons.push(coupon.ticket));

      this.isDldBasket = containsDelayedDeliveryProduct(this.basket);
      if (this.isDldBasket) {
        let newBasket = handleExtendasDelayedDelivery(this.basket);
        this.setBasket(newBasket);
      }

      let p = debit(
        this.currency_code,
        {
          basket: [...this.basket],
          coupons,
          delivery_method: this.delivery_method.identifier,
          puck: this.next_puck,
          ordernumber: this.ordernumber,
          terminal: this.terminal.terminal
        },
        this.terminal.terminal,
        this.basket.lineItems,
        this.basket.vatDetails,
        this.basket.coupons
      );

      //TODO: p is a Promise and allways truethy! if (!P) will never be executed! Block can be removed?
      if (!p) {
        //We dont' have a Terminal
        this.paymentFailed(new Error("No Terminal"));
        return;
      }
      p.then(this.payed, this.paymentFailed);
    },
    dld_succeeded() {
      console.log("dld_succeeded");
      this.dldTransmissionStatus = { success: true, error: "" };
    },
    dld_failed(err) {
      console.log("dld_failed " + err);
      this.dldTransmissionStatus = {
        success: false,
        error: "Transmission failed."
      };
    },
    payed(data) {
      if (this.isCikam) {
        this.setCikamResponse({});
      }
      this.paymentData = data;
      this.logAudit({
        category: "ORDER",
        event: "PAYMENT_DONE"
      });
      this.getProgress("pay").payment = "success";
      this.getProgress("pay").text = this.$t("payment.betaling.success");

      if (this.isQrCodeCheckout) {
        setTimeout(() => {
          this.submitPager()
            .then(this.submittedPager)
            .catch(err => {
              console.error("Creating pager failed.", err);
              this.pagerResponse = {};
            })
            .finally(() => {
              const TIMEOUT_QRCODE = 4000;
              console.log("triggerSubmitOrder qr code mode");
              this.triggerSubmitOrder(TIMEOUT_QRCODE);
            });
        }, 2000);
      } else if (this.isDldBasket) {
        transmission_status(this.paymentData.reference)
          .then(this.dld_succeeded, this.dld_failed)
          .finally(() => {
            const TIMEOUT_DLD = this.dldTransmissionStatus.success
              ? 2000
              : 8000;
            console.log("triggerSubmitOrder dld mode");
            this.triggerSubmitOrder(TIMEOUT_DLD);
          });
      } else {
        const TIMEOUT_TICKET = 2000;
        console.log("triggerSubmitOrder default mode");
        this.triggerSubmitOrder(TIMEOUT_TICKET);
      }
    },
    triggerSubmitOrder(timeout) {
      setTimeout(() => {
        this.submitOrder().then(this.submittedOrder);
      }, timeout);
    },
    paymentFailed(error) {
      let timeout = this.isCikam ? 250 : 2000;
      this.getProgress("pay").payment = "fail";
      this.getProgress("pay").text = this.$t("payment.betaling.fail");

      setTimeout(() => {
        let defaultErrorTitle = this.$t("payment.error");
        let defaultErrorText = error.toString();
        if (error.code) {
          this.currentPaymentErrorTitle = this.$t(
            "payment.error_" + error.code + "_title",
            defaultErrorTitle
          );
          this.currentPaymentErrorText = this.$t(
            "payment.error_" + error.code + "_text",
            defaultErrorText
          );
        } else {
          //default error messages
          this.currentPaymentErrorTitle = defaultErrorTitle;
          this.currentPaymentErrorText = defaultErrorText;
        }
        this.showError = true;
      }, timeout);
    },
    resetError() {
      this.showError = false;
      this.currentPaymentErrorTitle = "";
      this.currentPaymentErrorText = "";
    },
    abort() {
      if (this.isCikam) {
        console.log("abort - cancel cash payment");
        cancel(this.txid, this.terminal.terminal);
        this.setCikamResponse({});
      }
      this.resetError();
      this.logAudit({
        category: "PAGE",
        event: "CLOSE",
        data: "aborted order"
      });
      this.setBasket([]);
      this.logRouter({ name: "home", router: this.$router });
    },
    try_again() {
      if (this.isCikam) {
        this.setCikamResponse({});
      }
      this.resetError();
      this.prepare();
    },
    gotoOrderOrCheckout() {
      if (
        this.terminals &&
        this.terminals.length === 1 &&
        this.basket.length !== 0 &&
        !isScanEnabled(this.site_setting)
      ) {
        this.logRouter({ name: "order", router: this.$router });
      } else {
        this.logRouter({ name: "checkout", router: this.$router });
      }
    },
    confirm_cancel_cash_payment() {
      cancel(this.txid, this.terminal.terminal);
      this.showCancelModal = false;
      this.gotoOrderOrCheckout();
    },
    back_to_cart() {
      this.resetError();
      if (this.isCikam) {
        cancel(this.txid, this.terminal.terminal);
        this.gotoOrderOrCheckout();
      } else if (this.basket.length !== 0) {
        this.logRouter({ name: "order", router: this.$router });
      }
    },
    async submitPager() {
      let receipt = basketToReceipt(this.basket, this.coupons);
      let pagerPayload = {
        receipt: receipt,
        ordernumber: this.ordernumber,
        customer_language: this.current_language.code_short,
        txid: this.txid
      };
      let pagerRequest = await api.postPager(pagerPayload);
      let pagerResponse = pagerRequest.data;

      this.logAudit({
        category: "ORDER",
        event: "PAGER_CREATED",
        pagerResponse
      });
      this.getProgress("qrcode").title = "";
      this.getProgress("qrcode").text = this.$t("payment.qty.text");
      return pagerResponse;
    },
    async submitOrder() {
      if (!this.isQrCodeCheckout) {
        this.proceedWithStep("ticket");
        this.getProgress("ticket").title = this.$t("payment.ticket.title");
        this.getProgress("ticket").text = this.$t("payment.ticket.text");
      }
      let data = {
        receipt: basketToReceipt(this.basket, this.coupons),
        qr_code_data: this.pagerResponse.url,
        basket: [...this.basket],
        ordernumber: this.ordernumber,
        manual_puck: this.manual_puck,
        payment: this.paymentData,
        delivery_method: this.delivery_method,
        customer_language: this.current_language.code_short,
        customer_locale: this.current_language.locale,
        currency_code: this.currency_code,
        dld_data: getDldData(this.basket),
        vat_details: this.basket.vatDetails
      };
      this.logAudit({
        category: "ORDER",
        event: "CREATED",
        data
      });
      let request = await api.postBasket(data);
      let response = request.data;
      if (response.errorCode.name === "Success") {
        if (response.printersState) {
          let initialState = getInitialState(response.printersState);
          if (!response.productsOfTheShelfOnly) {
            // only set order number for 'kitchen'-orders
            let setOrderNumberResult = await this.setOrderNumberStatus(
              this.ordernumber,
              initialState,
              this.paymentData["txid"]
            );
            if (setOrderNumberResult) {
              if (setOrderNumberResult.error && setOrderNumberResult.info) {
                console.log(
                  "Setting order number status failed: " +
                    setOrderNumberResult.info
                );
              }
            }
          }
        }
        if (response.productsOfTheShelfOnly) {
          this.productsOfTheShelfOnly = true;
        }
        if (
          response.puck &&
          response.puck.result &&
          response.puck.result.count === 0
        ) {
          this.lock_kiosk({ code: "NoPuckLeft" });
        }
        // else if (
        //   ["PAPER_END", "CUSTOMER_PRINTER_ERROR", "PRINTER_TIMEOUT"].includes(
        //     response.customerPrinterCode
        //   )
        // ) {
        //   // this.setCustomerPrinterResponse(response.customerPrinterCode);
        //   this.lock_kiosk({ code: response.customerPrinterCode });
        // }
        if (response.customerPrinterCode) {
          this.setCustomerPrinterResponse(response.customerPrinterCode);
        }
        if (
          response.puck &&
          response.puck.result &&
          response.puck.result.nextPuck
        ) {
          // Only pyramid puck should end up here.
          this.setNextPuck({
            ...response.puck.result.nextPuck,
            type: "pyramid"
          });
        }
      } else {
        //TODO: lock here too?
      }
    },
    submittedPager(data) {
      this.proceedWithStep("qrcode");
      this.logAudit({
        category: "ORDER",
        event: "PAGER_CREATED",
        data
      });
      this.pagerResponse = data.response;
      // append scanmode GET parameter to URL to identify if the QR Code was scanned from receipt or from screen.
      let final_qrcode_url = data.response.url;
      let delimiter = final_qrcode_url.indexOf("?") === -1 ? "?" : "&";
      final_qrcode_url += delimiter + "scanmode=kiosk";
      let payload = {
        url: final_qrcode_url
      };
      api.postQrCode(payload).then(response => {
        const reader = new window.FileReader();
        reader.readAsDataURL(response.data);
        reader.onload = () => {
          if (typeof reader.result !== "string") {
            console.log("Setting qrCodeImage failed.");
            return;
          }
          document
            .getElementById("qrCodeImage")
            .setAttribute("src", reader.result);
        };
      });
    },
    submittedOrder() {
      if (this.productsOfTheShelfOnly) {
        this.logAudit({
          category: "ORDER",
          event: "PRODUCTS_OF_THE_SHELF_ONLY"
        });
      } else {
        this.logAudit({
          category: "ORDER",
          event: "PUK_DELIVERED"
        });
      }
      if (this.isQrCodeCheckout) {
        this.finalizedOrder();
      } else {
        setTimeout(() => {
          this.proceedWithStep("completion");
          this.finalizedOrder();
        }, 3000);
      }
    },
    finalizedOrder() {
      this.logAudit({
        category: "ORDER",
        event: "DONE",
        data: {
          ordernumber: this.ordernumber
        }
      });
      this.setManualPuck("");
      this.setNextPuck({});
      this.setBasket([]);
      this.isDone = true;
      this.$refs.orderHeader.paymentIsDone();
      this.timer = setTimeout(() => {
        this.home();
      }, 15000);
    },
    ...mapActions({ logRouter: "LOG_ROUTER", logAudit: "LOG_AUDIT" })
  },
  mounted() {
    this.prepare();
  },
  beforeDestroy() {
    if (this.timer) {
      console.log("beforeDestroy cancel 'redirect to home after 15 seconds'");
      clearTimeout(this.timer);
    }
  },
  watch: {
    insertedAmount(amount) {
      console.log("watch insertedAmount");
      this.$emit("insertedAmountChanged");
      if (amount === 0) {
        this.getProgress("pay").text = this.$t("payment.betaling.text_cash");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.qrCodeImage {
  background-color: #fff;
  border-radius: 45px;
  display: flex;
  flex-direction: column;
  height: 504px;
  justify-content: flex-start;
  width: 515px;
}

.qrCodeImage-Head {
  background-color: #252525;
  border-radius: 45px;
  color: white;
  font-size: 40px;
  font-family: var(--app_font-family_bold);
  line-height: 90px;
  min-height: 90px;
  text-align: center;
  text-transform: uppercase;
}

.qrCodeImage-Arrow {
  background-color: #252525;
  height: 38px;
  margin: -20px auto 20px;
  text-align: center;
  transform: rotate(45deg);
  width: 38px;
}

.qrCodeImage-ImgContainer {
  text-align: center;
}

.qrCodeImage-ImgContainer img {
  width: 360px;
  height: 360px;
}

.payBg {
  background: var(--page_Payment_background);
  height: 100vh;
  width: 100vw;
}

.payBg-hasBackgroundImage {
  background-image: var(--page_Payment_background-image);
}

.circleSpace {
  height: 605px;
}

.circleSpace-isQtyLayout {
  /* QtyLayout: height of progressBlock is increased by 320px, remove it here*/
  height: 285px;
}

.headerWrapper {
  position: absolute;
  top: 0;
  width: 1080px;
  text-align: center;
}

.headerTitle {
  color: var(--page_Payment_headerTitle_color);
  font-family: var(--page_Payment_headerTitle_font-family);
  font-size: var(--page_Payment_headerTitle_font-size);
  text-shadow: var(--page_Payment_headerTitle_text-shadow);
  text-transform: var(--page_Payment_headerTitle_text-transform);
  transform: var(--page_Payment_headerTitle_transform);
  line-height: var(--page_Payment_headerTitle_line-height);
  padding: var(--page_Payment_headerTitle_padding);

  &-isProgress {
    visibility: var(--page_Payment_headerTitle-isProgress_visibility);
  }

  &-isDone {
    visibility: var(--page_Payment_headerTitle-isDone_visibility);
  }
}

.statusBox {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 600px;
  margin-top: 100px;
  align-items: center;
}

.statusItem {
  display: flex;
  align-items: center;
  width: 55%;
}

.statusIcon {
  border: 3px solid #252525;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
}

.statusImg {
  height: 40px;
}

.progressTitle {
  font-family: var(--page_Payment_progressTitle_font-family);
  letter-spacing: 1.5px;
  font-size: var(--page_Payment_progressTitle_font-size);
  margin-bottom: 15px;
  text-transform: var(--page_Payment_progressTitle_text-transform);
  color: var(--page_Payment_color);
}

.progressText {
  font-family: var(--page_Payment_progressText_font-family);
  font-size: var(--page_Payment_progressText_font-size);
  color: var(--page_Payment_color);
  margin-bottom: 15px;
  text-align: center;
}

.progressTextCikam {
  /*TODO check if --page_Payment_progressText_font-family can be used */
  font-family: var(--app_font-family_regular);
}

.videoBlock {
  margin-top: 100px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.videoBlock-isQtyLayout {
  min-height: 583px;
  position: relative;
}

.videoSubtext {
  margin-top: 20px;
  width: var(--page_Payment_videoSubtext_width);
  font-family: var(--page_Payment_videoSubtext_font-family);
  color: var(--page_Payment_videoSubtext_color);
  font-size: var(--page_Payment_videoSubtext_font-size);
  text-align: center;
}

.progressBlock {
  display: flex;
  width: 100%;
  height: 280px;
  flex-direction: column;
  align-items: center;
}

.progressBlock-isQtyLayout {
  height: 600px;
}

.arrowBox {
  height: 600px;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 50px;
  display: none;
}

.end {
  display: flex;
  justify-content: flex-end;
}

.start {
  display: flex;
  justify-content: flex-start;
}

.arrowImg {
  height: 125px;
}

.active {
  color: #252525;
}

.inactive {
  color: #c3c3c3;
}

.active .statusIcon {
  border-color: #252525;
}

.inactive .statusIcon {
  border-color: #c3c3c3;
}

.numberBlock {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: -190px;
  position: relative;
  z-index: 15;
}

.numberText {
  color: #252525;
  text-transform: uppercase;
  font-size: 40px;
  margin-bottom: 25px;
}

.numberBox {
  background-color: var(--page_Payment_numberBox_background-color);
  background-image: var(--page_Payment_numberBox_background-image);
  background-size: contain;
  width: 250px;
  height: 250px;
  letter-spacing: 4px;
  color: var(--page_Payment_numberBox_color);
  text-transform: uppercase;
  font-family: var(--page_Payment_numberBox_font-family);
  font-size: var(--page_Payment_numberBox_font-size);
  line-height: var(--page_Payment_numberBox_font-size);
  padding: var(--page_Payment_numberBox_padding);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.resultBlock {
  display: flex;
  flex-direction: column;
  height: 68%;
}

.resultBlock-isQtyLayout {
  height: 78%;
}

.proposalBlock {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.proposalText {
  color: #252525;
  text-transform: uppercase;
  font-size: 26px;
  text-align: center;
  line-height: 40px;
}

.startBlock {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: var(--page_Payment_startBlock_bottom);
  width: 100%;
}

.actionBlock {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 0 60px;
  position: absolute;
  bottom: 80px;
}

.cancelBtn {
  width: 210px;
  height: 70px;
  border-radius: var(--page_Payment_cancelBtn_border-radius);
  font-family: var(--page_Payment_cancelBtn_font-family);
  border: var(--page_Payment_cancelBtn_border);
  color: var(--page_Payment_cancelBtn_color);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: var(--page_Payment_cancelBtn_font-size);
  padding: var(--page_Payment_cancelBtn_padding);
  background-color: var(--page_Payment_cancelBtn_background-color);
}

.startBtn {
  background: var(--page_Payment_startBtn_background);
  text-align: center;
  color: var(--page_Payment_startBtn_color);
  text-transform: var(--page_Payment_startBtn_text-transform);
  width: 712px;
  height: 70px;
  border-radius: var(--page_Payment_startBtn_border-radius);
  font-family: var(--page_Payment_startBtn_font-family);
  font-weight: var(--page_Payment_startBtn_font-weight);
  letter-spacing: var(--page_Payment_startBtn_letter-spacing);
  font-size: var(--page_Payment_startBtn_font-size);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: var(--page_Payment_startBtn_padding);
}

.startBtnInfoText {
  align-items: center;
  display: flex;
  font-size: 26px;
  justify-content: center;
  margin-top: 80px;
}

.proposalItem {
  width: 840px;
  margin-top: 60px;
}

.menuHeaderText {
  color: var(--page_Payment_menuHeaderText_color);
  font-family: var(--page_Payment_menuHeaderText_font-family);
  font-size: var(--page_Payment_menuHeaderText_font-size);
  text-align: center;
  text-transform: var(--page_Payment_menuHeaderText_text-transform);
  width: 600px;
}
</style>
